import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-action-confirmation-dialogue',
  standalone: true,
  imports: [],
  templateUrl: './action-confirmation-dialogue.component.html',
  styleUrl: './action-confirmation-dialogue.component.css'
})
export class ActionConfirmationDialogueComponent {
  constructor(
    public dialogRef: MatDialogRef<ActionConfirmationDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; label: string; confirmText: string; cancelText: string }
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
